import React, { Component } from 'react';
import pt from 'prop-types';
import {
  log,
  jsonStringifyIsEqual as isEqual,
} from '../../Helpers/helpers';
import { fetchByQuery, fetchByPost } from '../../Actions/search';
import { search } from '../../Reducers/search';
import queryString from 'qs';
import { withRouter } from 'react-router';
import Maps from '../../Maps';
import CONSTANTS from '../../Pages/findcare/constants';
import MapControls, { getBoundaryQuery } from './map-controls';
import Infowindow from './info-window';
import * as util from './helpers';

class Map extends Component {
  // Google api reference
  api = null;
  map = null;

  // We pass some custom config to the mapoption for the "new" map. Not used by the old one.
  // https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
  mapOptions = this.props.mapConfig.mapOption({ minZoom: 4 });

  // Bind `this` so the function can be passed to platformui component.
  handleClusterClick = this.handleClusterClick.bind(this);
  fetchInitialPins = this.fetchInitialPins.bind(this);
  onBoundsChanged = this.onBoundsChanged.bind(this);
  afterFitBounds = this.afterFitBounds.bind(this);

  //Set initial state
  state = search({
    bounds: util.getInitialBounds(this.props.SearchResult),
    center: util.getDefaultCenter(this.props.SearchResult),
    b: null, // fetch pins bounds
    pinsFetchedCenter: null, // check if we should enable/disable area search button
    boundarySearch: CONSTANTS.BOUNDARY_QUERY_ENABLED, // is area search button enabled
    zoom: null, // keep track of zoom level
    initialPinsFetched: false, // set to true after first fetch to pins api
    googleApiLoaded: false, // set to true when api is loaded
    mapIsLoaded: false,
    isLoading: false, // set to true when fetching pins (handled in platform search class)
    SearchHits: [], // locations to be displayed on map
  });

  dispatch(action) {
    this.setState(search(this.getState(), action));
  }

  getState() {
    return this.state;
  }

  fetchPins(query, config) {
    let center = config.center || {};

    if (this.props.IsPost) {
      const hsaIds = util.getHsaIdsPiped(this.props.SearchResult);
      const formData = new FormData();
      formData.append('HSAIDs', hsaIds);
      fetchByPost('/api/hjv/pins', formData)(
        this.dispatch.bind(this),
        this.getState.bind(this)
      );
    } else {
      const qs = queryString.parse(query, {
        ignoreQueryPrefix: true,
      });
      if (!qs.location) {
        qs.location = '';
      }
      if (!qs.s) {
        qs.s = CONSTANTS.SORT_DISTANCE;
      }
      // Overwrite lat and lng values in querystring.
      // We use the map center and not user location center to calculate
      // disatance when fetchning pins when not nearby search.
      if (qs.nearby !== 'true') {
        qs.lat = center.lat;
        qs.lng = center.lng;
      } else {
        center.lat = qs.lat;
        center.lng = qs.lng;
      }
      // t = Take
      // Use take variable or use default take 10 pins.
      qs.t = qs.t || 10;
      fetchByQuery(`/api/hjv/pins?${queryString.stringify(qs)}`)(
        this.dispatch.bind(this),
        this.getState.bind(this)
      );
    }
    // Save the center location to state when pins where fetched
    // To toggle "search in area" button.
    this.setState({
      pinsFetchedCenter: center,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const qsPrev = queryString.parse(prevProps.location.search, {
      ignoreQueryPrefix: true,
    });
    const qs = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    const [, setFindCareState] = this.props.findCareState;

    // Remove pagination variable.
    delete qsPrev.p;
    delete qs.p;

    if (
      this.state.googleApiLoaded &&
      this.state.mapIsLoaded &&
      this.state.b &&
      this.map &&
      this.api &&
      !this.state.initialPinsFetched &&
      !this.state.isLoading
    ) {
      this.setState({ isLoading: true });
      // Make sure we make the fetch when map has got good bounds.
      // not a very good solution.
      // TODO:
      // we should check when the map has settled after the
      // very first (10) pins are loaded.
      setTimeout(() => {
        this.fetchInitialPins({ map: this.map, api: this.api });
      }, 300);
    }

    if (prevState.isLoading === true && this.state.isLoading === false) {
      // log()("just loaded pins.", this.props.SearchResult, this.state);

      // If we need to modify search result inside the list component we
      // can do this here.
      let searchResultModifiers = {};
      setFindCareState('searchResultModifiers', searchResultModifiers);

      // We just finished loading pins.
      // Check if current center is equal to the center where we fetched pins.
      this.setState((state) => ({
        // If the positions are equal we disable the boundarySearch button.
        boundarySearch: isEqual(state.pinsFetchedCenter, state.center)
          ? state.boundarySearch
          : CONSTANTS.BOUNDARY_QUERY_ENABLED,
        // Set pin fetch center to null.
        pinsFetchedCenter: null,
      }));
    }

    // We look at the query string if it has changed we fetch new pins.
    // Not counting the pagination.
    if (!isEqual(qsPrev, qs)) {
      if (qs.b && qsPrev.b !== qs.b) {
        // New bounds
        setFindCareState('sortWithBoundary', null);
      }

      this.fetchPins(queryString.stringify(qs), {
        center: this.state.center,
      });
    }

    if (
      prevProps.SearchResult.SearchHits !== this.props.SearchResult.SearchHits
    ) {
      const locations = [];
      const hsaids = [];

      const addLocation = (location) => {
        if (!hsaids.includes(location.HsaId)) {
          hsaids.push(location.HsaId);
          locations.push(util.getLocationData(location));
        }
      };
      this.state.SearchHits.forEach(addLocation);
      this.props.SearchResult.SearchHits.forEach(addLocation);

      // Only update state if we added any results.
      if (locations.length > this.state.SearchHits.length) {
        this.setState({
          SearchHits: locations,
        });
      }
    }
  }

  handleMarkerClick(markerData, marker, map) {
    Infowindow(markerData, marker, map);
  }

  handleClusterClick(clusterData, cluster, map) {
    if (map.getZoom() > 7) {
      const isEqPosition = clusterData.every(
        util.isEqPositionTo(clusterData[0])
      );

      if (isEqPosition || map.getZoom() >= 18) {
        //We have more then one marker on this position, build up request object
        let hsaId = '';
        clusterData.forEach((position) => {
          hsaId = hsaId + `${position.data.HsaId}|`;
        });

        const pos = {
          HsaId: hsaId,
          Latitude: clusterData[0].data.Latitude,
          Longitude: clusterData[0].data.Longitude,
        };

        Infowindow(pos, cluster.getMarkers()[0], map, true);
      }
    }
  }

  /**
   * Will run after markers are drawn and directly after
   * map.setCenter() and map.fitBounds()
   */
  afterFitBounds(map) {
    // Make sure that the map does not get zoomed in to much
    util.setMaxZoom(map);
  }

  fetchInitialPins({ map, api }) {
    const [, setFindCareState] = this.props.findCareState;
    if (!this.state.initialPinsFetched) {
      let pinsQuery = queryString.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      // t = (Take) Number of items to get from server
      // If we have a search with bounds we will plot all the pins on the map
      pinsQuery.t = util.getTakeParam(this.props.SearchResult);
      // p = (Page) Initial request is always first page
      pinsQuery.p = 1;
      let boundarySearch = CONSTANTS.BOUNDARY_QUERY_ENABLED;
      //
      // Location search without bounds is when we do not get hits inside the bounds
      // so we get 10 [BatchSize] results.
      if (
        util.shouldDoInitialBoundaryQuery(pinsQuery, this.props.SearchResult)
      ) {
        // Get current bounds in the query format we send to backend.
        // add/overwrite [b]
        try {
          pinsQuery.b = getBoundaryQuery(map, api);
        } catch (e) {
          console.log('error', e);
        }
        // Make sure sort component can use boundaries
        setFindCareState('sortWithBoundary', pinsQuery.b);
        // remove [g] and [z]
        delete pinsQuery.g;
        delete pinsQuery.z;
        delete pinsQuery.nearby;
      } else {
        setFindCareState('sortWithBoundary', null);
      }

      if (pinsQuery.b) {
        // disable the "search in area button"
        boundarySearch = CONSTANTS.BOUNDARY_QUERY_DISABLED;
      }

      this.fetchPins(queryString.stringify(pinsQuery), {
        center: map.getCenter().toJSON(),
      });

      this.setState({ initialPinsFetched: true, boundarySearch });
    }
  }

  /** Check if pins are loading or search list is loading */
  isLoading() {
    return Boolean(this.props.SearchResult.isLoading || this.state.isLoading);
  }

  isNewCenter(map) {
    return !isEqual(map.getCenter().toJSON(), this.state.center);
  }

  isZoomOut(map) {
    return Boolean(map.getZoom() < this.state.zoom);
  }

  isBoundarySearchEnabled(map) {
    return Boolean(
      (this.isNewCenter(map) || this.isZoomOut(map)) && !this.isLoading()
    );
  }

  handleMapChange = ({ map }) => {
    this.setState((state) => ({
      center: map.getCenter().toJSON(),
      zoom: map.getZoom(),
      boundarySearch: this.isBoundarySearchEnabled(map)
        ? CONSTANTS.BOUNDARY_QUERY_ENABLED
        : state.boundarySearch,
    }));
  };

  onIdle = ({ map }) => {
    this.handleMapChange({ map });
  };

  onBoundsChanged({ map }) {
    const bounds = map.getBounds();
    if (!this.state.b && bounds) {
      this.setState({ b: bounds });
    }
  }

  createEventListeners() {
    return {
      idle: this.onIdle,
      zoom_changed: this.handleMapChange,
      bounds_changed: this.onBoundsChanged,
    };
  }

  render() {
    const props = this.props;
    const qs = queryString.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    // use zoom level from queryparam if used.
    const zoomLevel = util.getZoomLevel(qs);
    const googleMapEventListeners = this.createEventListeners();
    const { lat, lng } = this.state.center;
    // Do not fit bounds when we do "search in area" ie. queryparam "b" is set.
    const disableFitBounds = Boolean(qs.b);
    return (
      <Maps
        className="findcare-map__gmap"
        mapApiKey={props.apiKey}
        modifiers={{
          ...props.modifiers,
          'findcare-map__gmap--api-loaded': this.state.googleApiLoaded,
          'findcare-map__gmap--is-loading': this.state.isLoading,
          'findcare-map__gmap--is-markers-loading': this.isLoading(),
        }}
        zoom={zoomLevel}
        lat={lat}
        lng={lng}
        initialBounds={this.state.bounds}
        disableFitBounds={disableFitBounds}
        afterFitBounds={this.afterFitBounds}
        useClusters={true}
        eventListeners={googleMapEventListeners}
        onMarkerClick={this.handleMarkerClick}
        onClusterClick={this.handleClusterClick}
        onMapInit={({ map }) => {
          this.map = map;
          this.setState({ mapIsLoaded: true });
        }}
        onGoogleAPILoad={(api) => {
          //Ladda första 10 pinsen
          const SearchHits = props.SearchResult.SearchHits.map(
            util.getLocationData
          );
          this.api = api;

          this.setState(
            {
              googleApiLoaded: true,
              SearchHits,
            },
            () => {
              log()('SearchHits state set', SearchHits);
            }
          );
        }}
        options={this.mapOptions}
        markerOptions={props.mapConfig.markerOptions()}
        Locations={this.state.SearchHits}
        clusterMarkerIcons={props.mapConfig.clusterMarkerIcons()}
      >
        {(map, googleAPI) => (
          <MapControls
            {...props}
            map={map}
            isLoading={this.isLoading()}
            googleAPI={googleAPI}
            zoom={true}
            boundarySearch={this.state.boundarySearch}
            expand={props.expand}
          />
        )}
      </Maps>
    );
  }
}

Map.propTypes = {
  IsPost: pt.bool,

  SearchResult: pt.shape({
    BatchSize: pt.number,
    SearchHits: pt.arrayOf(
      pt.shape({
        HsaId: pt.string,
        Latitude: pt.number,
        Longitude: pt.number,
      })
    ).isRequired,
  }).isRequired,
  /** Google maps api key */
  apiKey: pt.string,
  /** If true <MapControls> will show expand button */
  expand: pt.bool,
  /** From withRouter() in 'react-router' */
  location: pt.object,
};

export default withRouter(Map);
